import api from './api';

export interface UserPreference {
  key: string;
  value: any;
}

export interface UserPreferenceResponse {
  success: boolean;
  data?: any;
  message?: string;
}

class UserPreferenceService {
  // 获取所有用户偏好设置
  async getAllPreferences(): Promise<UserPreferenceResponse> {
    const response = await api.get('/user-preferences');
    return response.data;
  }

  // 获取特定的用户偏好设置
  async getPreference(key: string): Promise<UserPreferenceResponse> {
    const response = await api.get(`/user-preferences/${key}`);
    return response.data;
  }

  // 设置单个用户偏好
  async setPreference(key: string, value: any): Promise<UserPreferenceResponse> {
    const response = await api.post('/user-preferences', { key, value });
    return response.data;
  }

  // 批量设置用户偏好
  async setBatchPreferences(preferences: Record<string, any>): Promise<UserPreferenceResponse> {
    const response = await api.post('/user-preferences/batch', { preferences });
    return response.data;
  }

  // 删除用户偏好设置
  async deletePreference(key: string): Promise<UserPreferenceResponse> {
    const response = await api.delete(`/user-preferences/${key}`);
    return response.data;
  }

  // 列设置相关的便捷方法
  async getColumnSettings(page: string, serviceType?: string, subService?: string): Promise<string[]> {
    const key = serviceType ? (subService ? `${page}_columns_${serviceType}_${subService}` : `${page}_columns_${serviceType}`) : `${page}_columns`;
    try {
      const response = await this.getPreference(key);
      if (response.success && response.data?.value) {
        const value = response.data.value;
        // 后端已经处理了JSON解析，直接检查类型
        return Array.isArray(value) ? value : [];
      }
      return [];
    } catch (error) {
      console.warn('获取列设置失败:', error);
      return [];
    }
  }

  async saveColumnSettings(page: string, columns: string[], serviceType?: string, subService?: string): Promise<boolean> {
    const key = serviceType ? (subService ? `${page}_columns_${serviceType}_${subService}` : `${page}_columns_${serviceType}`) : `${page}_columns`;
    try {
      const response = await this.setPreference(key, columns);
      return response.success;
    } catch (error) {
      console.error('保存列设置失败:', error);
      return false;
    }
  }

  // 每页条数设置相关的便捷方法
  async getPageSizeSettings(page: string, serviceType?: string): Promise<number> {
    const key = serviceType ? `${page}_pageSize_${serviceType}` : `${page}_pageSize`;
    try {
      const response = await this.getPreference(key);
      if (response.success && response.data?.value) {
        const value = response.data.value;
        // 后端已经处理了JSON解析，直接检查类型
        return typeof value === 'number' ? value : 10;
      }
      return 10; // 默认10条/页
    } catch (error) {
      console.warn('获取每页条数设置失败:', error);
      return 10;
    }
  }

  async savePageSizeSettings(page: string, pageSize: number, serviceType?: string): Promise<boolean> {
    const key = serviceType ? `${page}_pageSize_${serviceType}` : `${page}_pageSize`;
    try {
      const response = await this.setPreference(key, pageSize);
      return response.success;
    } catch (error) {
      console.error('保存每页条数设置失败:', error);
      return false;
    }
  }
}

const userPreferenceService = new UserPreferenceService();
export default userPreferenceService;
